import * as moment from 'moment'
import * as React from 'react'
import './style.scss'

interface IProps {
  title: string
  location: string
  date: Date
  text: string
  edit?: boolean
  borderBottom?: boolean
}

export class Publication extends React.PureComponent<IProps> {
  render() {
    const { title, location, date, text, edit, borderBottom } = this.props
    return (
      <div className={`publication ${borderBottom && 'borderBottom'}`}>
        <h2 className={`title ${edit ? 'edit' : ''}`}>{title}</h2>
        <h4 className={`details ${edit ? 'edit' : ''}`}>
          {location} | {moment(date).format('MMMM YYYY')}
        </h4>
        <p className={`text ${edit ? 'edit' : ''}`}>
          {text.length > 140 ? text.slice(0, 140) + '...' : text}
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Publication/index.tsx